import React from 'react'
import { Checkbox, Intent } from '@blueprintjs/core'

export default function CustomCheckbox({
  blue,
  intent,
  style,
  ...checkboxProps
}: {
  blue?: boolean
  intent: Intent
  style?: any
  label: string
  checked: boolean
  onChange: () => void
}) {
  const className = blue ? 'blue' : `bp4-checkbox-override-${intent}`
  return (
    <div className={className} {...{ style }}>
      <Checkbox {...checkboxProps} />
    </div>
  )
}
